export default __webpack_public_path__ + "static/media/plan.b241439f.svg";